(function () {
  'use strict';

  const IMGBB_API_KEY = 'd2d355ed1eaa81ec0ddaec07de0a0496';

  function initForm(sectionId) {
    const productForm = document.getElementById('product-form-' + sectionId);
    if (!productForm) return;

    const nameInput    = document.getElementById('sq-name-' + sectionId);
    const detailsInput = document.getElementById('sq-details-' + sectionId);
    const photoInput   = document.getElementById('sq-photo-' + sectionId);

    const hiddenName    = document.getElementById('sq-hidden-name-' + sectionId);
    const hiddenDetails = document.getElementById('sq-hidden-details-' + sectionId);
    const hiddenPhoto   = document.getElementById('sq-photo-url-' + sectionId);

    const statusEl    = document.getElementById('sq-upload-status-' + sectionId);
    const previewWrap = document.getElementById('sq-preview-wrap-' + sectionId);
    const previewImg  = document.getElementById('sq-preview-img-' + sectionId);
    const placeholder = document.getElementById('sq-upload-placeholder-' + sectionId);
    const removeBtn   = document.getElementById('sq-remove-photo-' + sectionId);
    const nameError    = document.getElementById('sq-name-error-' + sectionId);
    const detailsError = document.getElementById('sq-details-error-' + sectionId);
    const photoError   = document.getElementById('sq-photo-error-' + sectionId);

    let uploadInProgress = false;

    // ── Sync visible → hidden ────────────
    function syncValues() {
      if (hiddenName)    hiddenName.value    = nameInput    ? nameInput.value.trim()    : '';
      if (hiddenDetails) hiddenDetails.value = detailsInput ? detailsInput.value.trim() : '';
    }

    nameInput?.addEventListener('input', syncValues);
    detailsInput?.addEventListener('input', syncValues);

    // ── Helpers ───────────────────
    function setStatus(msg, type) {
      if (!statusEl) return;
      statusEl.textContent = msg;
      statusEl.className = 'sq-upload-status ' + type;
    }

    function showError(el, show) {
      if (!el) return;
      el.classList.toggle('visible', show);
    }

    // ── Validation — returns true if valid ────────────
    function validateForm() {
      syncValues();
      let valid = true;

      // Name
      if (!nameInput?.value.trim()) {
        showError(nameError, true);
        nameInput?.classList.add('sq-input--error');
        if (valid) nameInput?.focus();
        valid = false;
      } else {
        showError(nameError, false);
        nameInput?.classList.remove('sq-input--error');
      }

      // Details — REQUIRED
      if (!detailsInput?.value.trim()) {
        showError(detailsError, true);
        detailsInput?.classList.add('sq-input--error');
        valid = false;
      } else {
        showError(detailsError, false);
        detailsInput?.classList.remove('sq-input--error');
      }

      // Photo
      if (!hiddenPhoto?.value) {
        showError(photoError, true);
        valid = false;
      } else {
        showError(photoError, false);
      }

      return valid;
    }

    // ── Disable ALL checkout buttons ────
    function setButtonsDisabled(disabled) {
      // Add to Cart
      const addBtn = productForm.querySelector('[name="add"]');
      if (addBtn) addBtn.disabled = disabled;

      // Shopify dynamic checkout (Buy Now / GPay / etc.)
      document.querySelectorAll('.shopify-payment-button__button').forEach(b => {
        b.disabled = disabled;
      });

      // Shiprocket Buy Now button — intercept clicks when uploading
      document.querySelectorAll('[data-shiprocket-buy-now], .sr-buy-now, .shiprocket-buy-now').forEach(b => {
        b.disabled = disabled;
      });
    }

    // ── Intercept ANY Buy Now / dynamic checkout click ────
    function interceptBuyNow(e) {
      if (uploadInProgress) {
        e.preventDefault();
        e.stopImmediatePropagation();
        setStatus('⏳ Photo is still uploading, please wait...', 'uploading');
        return;
      }
      if (!validateForm()) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    }

    // Attach to Shopify payment buttons container (covers GPay, PayPal, Buy Now)
    function attachBuyNowListeners() {
      // Shopify dynamic checkout wrapper
      document.querySelectorAll('.shopify-payment-button, .shopify-payment-button__button').forEach(btn => {
        btn.removeEventListener('click', interceptBuyNow, true);
        btn.addEventListener('click', interceptBuyNow, true);
      });

      // Shiprocket specific selectors
      document.querySelectorAll('[data-shiprocket-buy-now], .sr-buy-now, .shiprocket-buy-now, [class*="shiprocket"]').forEach(btn => {
        btn.removeEventListener('click', interceptBuyNow, true);
        btn.addEventListener('click', interceptBuyNow, true);
      });
    }

    // Run now + after DOM changes (Shiprocket injects buttons dynamically)
    attachBuyNowListeners();
    const observer = new MutationObserver(attachBuyNowListeners);
    observer.observe(document.body, { childList: true, subtree: true });

    // ── Photo Upload ───
    photoInput?.addEventListener('change', function () {
      const file = this.files[0];
      if (!file) return;

      if (file.size > 10 * 1024 * 1024) {
        setStatus('File is larger than 10MB. Select a smaller image.', 'error');
        this.value = '';
        return;
      }

      const reader = new FileReader();
      reader.onload = function (e) {
        if (previewImg)  previewImg.src = e.target.result;
        if (previewWrap) previewWrap.style.display = 'inline-block';
        if (placeholder) placeholder.style.display = 'none';
      };
      reader.readAsDataURL(file);

      uploadPhoto(file);
    });

    removeBtn?.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (photoInput)  photoInput.value = '';
      if (hiddenPhoto) hiddenPhoto.value = '';
      if (previewWrap) previewWrap.style.display = 'none';
      if (placeholder) placeholder.style.display = 'flex';
      setStatus('', '');
      showError(photoError, false);
    });

    async function uploadPhoto(file) {
      uploadInProgress = true;
      if (hiddenPhoto) hiddenPhoto.value = '';
      setButtonsDisabled(true);
      setStatus('⏳ Photo uploading...', 'uploading');

      try {
        const fd = new FormData();
        fd.append('image', file);

        const res  = await fetch('https://api.imgbb.com/1/upload?key=' + IMGBB_API_KEY, {
          method: 'POST',
          body: fd
        });
        const data = await res.json();

        if (data.success && data.data?.url) {
          if (hiddenPhoto) hiddenPhoto.value = data.data.url;
          setStatus('✅ Photo uploaded!', 'success');
          setButtonsDisabled(false);
          showError(photoError, false);
        } else {
          throw new Error(data.error?.message || 'Upload failed');
        }
      } catch (err) {
        console.error('Upload error:', err);
        setStatus('❌ Upload failed. Try again.', 'error');
        setButtonsDisabled(false);
        if (photoInput)  photoInput.value = '';
        if (previewWrap) previewWrap.style.display = 'none';
        if (placeholder) placeholder.style.display = 'flex';
      } finally {
        uploadInProgress = false;
      }
    }

    // ── Add to Cart form submit ────────
    productForm.addEventListener('submit', function (e) {
      if (uploadInProgress) {
        e.preventDefault();
        e.stopImmediatePropagation();
        setStatus('⏳ Photo is still uploading, please wait...', 'uploading');
        return;
      }
      if (!validateForm()) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    }, true);

    // ── Live error clear ──────────
    nameInput?.addEventListener('input', function () {
      if (this.value.trim()) {
        showError(nameError, false);
        this.classList.remove('sq-input--error');
      }
    });

    detailsInput?.addEventListener('input', function () {
      if (this.value.trim()) {
        showError(detailsError, false);
        this.classList.remove('sq-input--error');
      }
    });
  }

  // ── Boot ──────────────
  function boot() {
    document.querySelectorAll('[id^="sq-personalization-form-"]').forEach(function (el) {
      initForm(el.id.replace('sq-personalization-form-', ''));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
